import React, { FC } from 'react';
import classnames from 'classnames';

import styles from './_Progress.module.css';

interface ProgressProps {
    text?: string;
    dateTime?: string;
    value: number;
    maxValue: number;
    type?: 'default' | 'inline';
}

export const Progress: FC<ProgressProps> = ({
    text,
    dateTime,
    value,
    maxValue,
    type = 'default',
}) => {
    const progress = value && maxValue ? value / maxValue : 0;
    const percent = Math.max(0, Math.min(progress, 1));
    const tranlateX = Math.round((percent - 1) * 100);

    return (
        <div className={classnames(styles.root, { [styles.inline]: type === 'inline' })}>
            {text && (
                <time className={styles.time} dateTime={dateTime}>
                    {text}
                </time>
            )}
            {progress > 0 && (
                <div className={styles.progress}>
                    <div
                        className={styles.progressBar}
                        style={{ transform: `translateX(${tranlateX}%)` }}
                    />
                </div>
            )}
        </div>
    );
};
